import CryptoJS from "crypto-js";
let SECRET_KEY = import.meta.env.VITE_SECRET_KEY;
const user_key = import.meta.env.VITE_AUTH_KEY;
import { jwtDecode } from "jwt-decode";
import moment from "moment";

export function encryptData(data) {
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    CryptoJS.enc.Utf8.parse(SECRET_KEY),
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    },
  );
  return {
    iv: CryptoJS.enc.Base64.stringify(iv),
    payload: encrypted.toString(),
  };
}

export const encoded = (payload) => {
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(payload), SECRET_KEY).toString();
  return ciphertext;
};

export const decodedPlaload = (text) => {
  if (text) {
    const cleanedText = text.replace(/&news_id=[^&]+/g, "");
    const bytes = CryptoJS.AES.decrypt(cleanedText, SECRET_KEY);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);

    // Try to parse as JSON first
    try {
      const parse = JSON.parse(originalText);
      return parse;
    } catch (jsonError) {
      // If JSON parsing fails, return the raw string (might be a JWT)
      return originalText;
    }
  } else {
    return null;
  }
};

export function decryptData(encryptedData) {
  const iv = CryptoJS.enc.Base64.parse(encryptedData.iv);
  const decrypted = CryptoJS.AES.decrypt(
    encryptedData.payload?.replace(/&news_id=[^&]+/g, "")?.replace(/&isPrevous=[^&]+/g, ""),
    CryptoJS.enc.Utf8.parse(SECRET_KEY),
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
};

export function decryptStorage() {
  const iv = CryptoJS.enc.Base64.parse(encryptedData.iv);
  const decrypted = CryptoJS.AES.decrypt(
    encryptedData.payload,
    CryptoJS.enc.Utf8.parse(SECRET_KEY),
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    },
  );
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}

function isExpired(currentDate, expireDate) {
  const parseDate = (dateStr) => {
    let cleanStr = dateStr.replace(/\s?(AM|PM)/i, '');
    let [datePart, timePart] = cleanStr.split(' ');
    let [day, month, year] = datePart.split('-');
    let [hours, minutes, seconds] = timePart.split(':');
    return new Date(year, month - 1, day, hours, minutes, seconds);
  };
  const current = parseDate(currentDate);
  const expire = parseDate(expireDate);
  return current > expire;
}

export function getTokenExp() {
  let url = window.location.href;
  let tkn = url?.split("token=")[1];
  if (localStorage.getItem("USER_AUTHERISTAION") != null) {
    let usr = localStorage.getItem('USER_AUTHERISTAION');
    let t = decodedPlaload(usr);
    const tt = decodedPlaload(t.token);
    const decoded = jwtDecode(tt);
    const expire = moment(decoded.exp * 1000).format("DD-MM-YYYY HH:mm:ss A")
    let curDate = new Date();
    let current = moment(curDate).format("DD-MM-YYYY HH:mm:ss A");
    const expired = isExpired(current, expire);
    console.log("aaaa",expired);
    return expired
  } else if (tkn) {
    let t = decodedPlaload(tkn);
    const tt = decodedPlaload(t.token);
    const decoded = jwtDecode(tt);
    const expire = moment(decoded.exp * 1000).format("DD-MM-YYYY HH:mm:ss A")
    let curDate = new Date();
    let current = moment(curDate).format("DD-MM-YYYY HH:mm:ss A");
    const expired = isExpired(current, expire);
    return expired
  }
  else {
    return true
  }
}
